import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '影片索引', href: '#index' },
  { label: '热度榜单', href: '#ranking' },
  { label: '观众热评', href: '#comments' },
  { label: '联系我们', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className="flex items-center gap-2 cursor-pointer"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-accent-500 rounded-lg">
              <i className="ri-movie-2-fill text-background-50 text-xl"></i>
            </div>
            <span className="text-lg md:text-xl font-bold font-heading text-foreground-50 tracking-wide">
              8848<span className="text-accent-400">影院</span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-2 text-sm font-medium text-foreground-300 hover:text-foreground-50 transition-colors rounded-lg hover:bg-background-200/50 cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button className="px-5 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              开始观影
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-200 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav className="md:hidden bg-background-100/98 backdrop-blur-md border-b border-background-200/60 px-4 pb-4">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="block py-3 px-3 text-sm font-medium text-foreground-300 hover:text-foreground-50 transition-colors rounded-lg hover:bg-background-200/40 cursor-pointer"
            >
              {item.label}
            </a>
          ))}
          <button className="mt-3 w-full px-5 py-2.5 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
            开始观影
          </button>
        </nav>
      )}
    </header>
  );
}